import type { PropsWithChildren } from "react";

export const Container = ({ children }: PropsWithChildren<unknown>) => (
  <div className="flex flex-col rounded-3xl bg-primary mx-5 md:mx-0 p-6 md:p-8 shadow-xl gap-y-6">
    {children}
  </div>
);
